import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export type Term = ApiSchemas['TermPresenter']

export default {
  async getById(id: number) {
    return wrapEndpoint(() =>
      client.GET('/term/{id}', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },
  async getLatest() {
    return wrapEndpoint(() => client.GET('/term/latest'))
  },
  async create(body: ApiSchemas['CreateTermDto']) {
    return wrapEndpoint(() =>
      client.POST('/term', {
        body,
      }),
    )
  },
  async updateById(id: number, body: ApiSchemas['UpdateTermDto']) {
    return wrapEndpoint(() =>
      client.PUT('/term/{id}', {
        params: {
          path: {
            id,
          },
        },
        body,
      }),
    )
  },
  async accept(termId: number) {
    return wrapEndpoint(() =>
      client.PATCH('/user/term/{termId}/accept', {
        params: {
          path: {
            termId,
          },
        },
      }),
    )
  },
}
